import { channel } from './channel';

export function setNetworkStatus(isOnline: boolean) {
	channel.postMessage({
		serviceWorker: {
			message: isOnline ? 'networkIsOnline' : 'networkIsOffline',
		},
	});
}
